.aw{padding:0.5rem;}